import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthServiceInterface } from '@freelancer/auth';
import { RedirectToPhp } from '@freelancer/redirect-to-php';
import { switchMap } from 'rxjs/operators';
import { LOGIN_AUTH_SERVICE, LOGIN_REDIRECT_SERVICE } from './login.config';
import { LoginServiceInterface } from './login.interface';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(
    @Inject(LOGIN_REDIRECT_SERVICE) private loginService: LoginServiceInterface,
    @Inject(LOGIN_AUTH_SERVICE) private auth: AuthServiceInterface,
    private router: Router,
    private redirectToPhp: RedirectToPhp,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.auth.isLoggedIn().pipe(
      switchMap(loggedIn => {
        const { next } = route.queryParams;
        // FIXME: temporary hack to unbreak T133950.
        const { goto } = route.queryParams;
        if (goto) {
          return this.redirectToPhp.doRedirect(state.url);
        }
        if (loggedIn) {
          return this.router.navigate([next || '/']);
        }
        return this.loginService.redirect(next, route);
      }),
    );
  }
}
